import { useEffect, useState } from "react"
import { getOxeState } from "../../store/actions/OxeActions"
import { useNavigate } from "react-router-dom"
import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { useDispatch } from "react-redux"

const OxeAuth = () => {

    const [loading, setLoader] = useState()

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        setLoader(true)
        validateOxeState()
    }, [])

    const validateOxeState = () => {
        dispatch(getOxeState(validateOxeState, (status) => {
            if(status) {
                navigate("/")
            } else {
                navigate("/unauthorized")
            }

            setLoader(false)
        }))
    }


    return <div className="align-vw-center ">
        <Spin spinning={loading} indicator={<LoadingOutlined />} size="large" wrapperClassName={loading ? "spin-active" : "spin-idle"}></Spin>
    </div>
}

export default OxeAuth